import React from "react";
import PasswordField from "./PasswordField/PasswordField";

function PasswordConfirm() {
  return (
    <>
      <div className="d-lg-none verifyEmailLogo">
        {/* <img src={logo} className="mb-3 h_66x object-fit-contain" alt="" /> */}
      </div>
      <PasswordField />
    </>
  );
}

export default PasswordConfirm;
